import React from 'react'
import { Link as GatsbyLink } from 'gatsby'
import { ExternalLinkIcon } from '@chakra-ui/icons'
import { Link, type LinkProps } from '@chakra-ui/react'

interface Props extends LinkProps {
    to: string
    colorScheme?: string
}

export default function InternalLink({
    children,
    to,
    colorScheme = 'brand',
    ...props
}: Props) {
    const { color, hoverColor } = getColorSchemeProps(colorScheme)

    return (
        <Link
            as={GatsbyLink}
            color={color}
            fontWeight="medium"
            _hover={{ color: hoverColor, textDecoration: 'underline' }}
            to={to}
            {...props}
        >
            {children} <ExternalLinkIcon mx="2px" />
        </Link>
    )
}

function getColorSchemeProps(colorScheme: string): {
    color: string
    hoverColor: string
} {
    switch (colorScheme) {
        case 'brand':
            return {
                color: 'brand.500',
                hoverColor: 'brand.600',
            }
        default:
            return {
                color: 'gray.800',
                hoverColor: 'gray.600',
            }
    }
}
